import ReactDOM from 'react-dom';

// React 19 moves findDOMNode to an internal object that suppresses Strict Mode warnings.
// React 18 doesn't have that object, so we fall back to ReactDOM.findDOMNode.
// This must be a function (not a module-level const) because React 19 initializes
// __DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE.findDOMNode as null
// at module load time — the actual function is injected later by the renderer.
export const findDOMNode = instance => {
  var _domInternals$findDOM;
  const domInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  const fn = (_domInternals$findDOM = domInternals === null || domInternals === void 0 ? void 0 : domInternals.findDOMNode) !== null && _domInternals$findDOM !== void 0 ? _domInternals$findDOM : ReactDOM.findDOMNode;
  return fn ? fn(instance) : null;
};